import React from 'react'
import Header from '../Components/Main/Header'
import { Outlet } from 'react-router-dom'
import Footer from '../Components/Main/Footer'

function Layout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  )
}

export default Layout
